import { Panel } from "@components/global/new/Panel/Panel";
import Title from "@components/global/new/Title/Title";
import { ALGOS_E } from "@constants/Algos";
import { UserRole } from "@services/http/responses/AccountResponse";
import UserTags from "../../../../global/new/UserTags/UserTags";
import StartMining from "../../StartMining/StartMining";
import MinerPlan from "../MinerPlan/MinerPlan";
import AdminNotesForm from "./AdminNotesForm/AdminNotesForm";
import CloneSettings from "./CloneSettings/CloneSettings";
import MinerChart from "./MinerChart";
import MinerDataFields from "./MinerDataFields/MinerDataFields";
import { default as classNames, default as cn } from "classnames";
import MinerErrors from "./MinerRowMoreSettings/MinerErrors/MinerErrors";
import NotesForm from "./NotesForm/NotesForm";
import { ExpandAltOutlined, ShrinkOutlined } from "@ant-design/icons";
import { useState } from "react";
import styles from "./MinerRowMore.module.scss";
import useMinerRowMoreChartControl from "./MinerRowMoreChart.control";
import { useIntl } from "react-intl";
import { Flex } from "antd";

function MinerRowMoreChart(): JSX.Element {

  const { formatMessage } = useIntl();
  const [maximized, setMaximized] = useState(false);
  const control = useMinerRowMoreChartControl();

  return (
    <>
      <Flex gap={20}>
        <Flex vertical className={classNames(styles.chart, { [styles.max]: maximized })}>
          <div className={styles.chartHead}>
            <Title className={styles.title}>
              {formatMessage({ id: "machines.more.hashrate.title" })}
            </Title>
            {maximized
              ? <ShrinkOutlined className={styles.scale} onClick={() => setMaximized(!maximized)} />
              : <ExpandAltOutlined className={styles.scale} onClick={() => setMaximized(!maximized)} />}
          </div>
          <Panel
            theme="light"
            className={cn(styles.section, styles.fill)}
          >
            <MinerChart
              chartClassName={styles.chart_more}
              minerId={control.miner.id}
              minerMinerId={control.miner.miner_id}
              defaultSpeed={control.miner.profile.performance}
              speedDropsPercent={control.miner.speed_drop}
              currentSpeed={control.miner.speed_current}
              poolHash={control.miner.hash}
              currentState={control.miner.status}
              currentAccepted={control.miner.accepted || 0}
              currentRejected={control.miner.rejected || 0}
            />
          </Panel>
        </Flex>
        <Flex vertical>
          <Title className={styles.title}>
            {formatMessage({ id: "plan.title" })} {control.miner.plan?.name}
          </Title>
          <Panel
            theme="light"
            className={cn(styles.section, styles.fill)}
          >
            {control.isAdmin && !!control.miner.tags && (
              <div className={styles.tags}>
                <UserTags
                  tags={control.miner.tags}
                  color={control.miner.user_color}
                  slicer={control.miner.tags.length}
                />
              </div>
            )}
            <MinerPlan />
          </Panel>
        </Flex>
      </Flex>
      <div className={styles.notes}>
        <div className={styles.notesForms}>
          <NotesForm
            value={control.miner.user_note}
            type="user_note"
            editable={control.currentRole === UserRole.User}
          />
          {control.currentRole === UserRole.Admin && (
            <>
              <NotesForm
                value={control.miner.admin_note}
                type="admin_note"
                editable={control.currentRole === UserRole.Admin}
              />
              <NotesForm
                value={control.miner.sync_note}
                type="sync_note"
              />
            </>
          )}
        </div>
        <AdminNotesForm minerId={control.miner.id} />
      </div>
    </>
  );
}

export default MinerRowMoreChart;